import { render, staticRenderFns } from "./Role.vue?vue&type=template&id=0e2fe568&scoped=true&"
import script from "./Role.vue?vue&type=script&lang=js&"
export * from "./Role.vue?vue&type=script&lang=js&"
import style0 from "./Role.vue?vue&type=style&index=0&id=0e2fe568&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2fe568",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e2fe568')) {
      api.createRecord('0e2fe568', component.options)
    } else {
      api.reload('0e2fe568', component.options)
    }
    module.hot.accept("./Role.vue?vue&type=template&id=0e2fe568&scoped=true&", function () {
      api.rerender('0e2fe568', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/Role.vue"
export default component.exports